// src/components/AppLayout.tsx

import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { OfflineBanner } from './OfflineBanner';
import { UpdateToast } from './UpdateToast';

export function AppLayout() {
  return (
    <div className="app-layout">
      <Header />
      <OfflineBanner />
      <main className="app-content">
        <Outlet />
      </main>
      <UpdateToast />
    </div>
  );
}
